import React from 'react';
import { Button, SearchField, Title } from '@gerdau/hefesto';
import { Header, HeaderActionWraper, SearchFieldWrapper } from './styles';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { ERoutes } from '../../../routes';

import { ApplicationState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  loadHelpCenter,
  loadHelpCenterCategories
} from '../../../store/ducks/help-center/actions';
import { EHelpCenterRoutes } from '..';
import { GetFlag } from '../../../utils/featureFlag';

export const HelpCenterHeader = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isNewApiEnabled = GetFlag('help_center_new_api');

  const FAQ = useSelector((state: ApplicationState) => state.helpCenter.faq);
  const commerce = useSelector(
    (state: ApplicationState) => state.helpCenter.commerce
  );
  const helpCenterLoading = useSelector(
    (state: ApplicationState) => state.helpCenter.loading
  );
  const customersState = useSelector(
    (appState: ApplicationState) => appState.customers
  );

  const [searchTerm, setSearchTerm] = React.useState('');

  const currentCategoryId = pathname
    .split(`${EHelpCenterRoutes.CATEGORY}/`)[1]
    ?.split('/')[0];

  const categoryTitle = isNewApiEnabled
    ? commerce.categories.find(
        (item) => String(item.category_id) === currentCategoryId
      )?.name
    : FAQ.categories.find((item) => pathname.includes(item.id))?.title;

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchTerm.length >= 3) {
      setSearchTerm('');
      history.push(
        `${ERoutes.HELP_CENTER}${EHelpCenterRoutes.SEARCH}?${searchTerm}`
      );
    }
  };

  const customerLoading =
    customersState.loading ||
    !!customersState.loadingPurchaseReceivers ||
    !!customersState.loadingProductDescription ||
    !!customersState.loadingBlocks ||
    !!customersState.loadingCustomerById;

  const loading = isNewApiEnabled
    ? commerce.loadingCategories || commerce.loadingTopics || customerLoading
    : helpCenterLoading || customerLoading;

  React.useEffect(() => {
    (() => {
      if (
        !customerLoading &&
        customersState.initialized &&
        !pathname.includes(EHelpCenterRoutes.SEARCH)
      )
        dispatch(
          isNewApiEnabled ? loadHelpCenterCategories() : loadHelpCenter()
        );
    })();
  }, [customerLoading, customersState, pathname, isNewApiEnabled]);

  const getBreadcrumbs = () => {
    return [
      { name: 'Suporte Gerdau mais', url: ERoutes.HELP_CENTER },
      ...(pathname.includes(EHelpCenterRoutes.SEARCH)
        ? [
            {
              name: `Resultados da busca`,
              url: ''
            }
          ]
        : []),
      ...(categoryTitle
        ? [
            {
              name: categoryTitle,
              url: ''
            }
          ]
        : [])
    ];
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key.toLowerCase() === 'enter') {
      e.preventDefault();

      const formEvent = new Event('submit', { bubbles: true });
      const form = e.currentTarget.closest('form') as HTMLFormElement;
      form?.dispatchEvent(formEvent);
    }
  };

  const showBreadcrumbs =
    !!categoryTitle || pathname.includes(EHelpCenterRoutes.SEARCH);

  const title = categoryTitle ?? 'Suporte Gerdau mais';

  return (
    <Header showBreadcrumbs={showBreadcrumbs}>
      {showBreadcrumbs && (
        <Breadcrumbs
          breadcrumbItems={getBreadcrumbs()}
          onClick={() =>
            history.push(`${ERoutes.HELP_CENTER}${EHelpCenterRoutes.CONTENT}`)
          }
        />
      )}
      <Title level={1}>{title ?? ''}</Title>
      {!showBreadcrumbs && (
        <span className="subtitle">
          Encontre respostas para as principais dúvidas e orientações sobre a
          Gerdau mais nas categorias abaixo.
        </span>
      )}

      <HeaderActionWraper onKeyUp={handleKeyDown} onSubmit={handleSearch}>
        <SearchFieldWrapper>
          <SearchField
            label=""
            name="helpcenter_query"
            placeholder="Descreva o que você busca"
            inputValue={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value.trim());
              // debouncedQuery(e.target.value);
            }}
            // searchResultOptions={suggestions}
            hideLabel
          />
        </SearchFieldWrapper>

        <Button
          style={{ minWidth: '172px', height: '48px' }}
          name="helpcenter_search_button"
          disabled={!searchTerm || searchTerm.length < 3 || loading}
          loading={loading}
          onClick={handleSearch}
        >
          Buscar
        </Button>
      </HeaderActionWraper>
    </Header>
  );
};
